export default [
  {
    path: "/pengguna",
    component: () => import("@/pages/users/user-list.vue"),
    meta: {
      requiredLevel: "admin",
    },
  },
  {
    path: "/pengguna/update/:id",
    component: () => import("@/pages/users/user-edit.vue"),
    meta: {
      requiredLevel: "admin",
    },
  },
  {
    path: "/pengguna/password/:id",
    component: () => import("@/pages/users/user-password.vue"),
    meta: {
      requiredLevel: "admin",
    },
  },
  {
    path: "/pengguna/create",
    component: () => import("@/pages/users/user-create.vue"),
    meta: {
      requiredLevel: "admin",
    },
  },
  {
    path: "/profil",
    component: () => import("@/pages/profil/Profil.vue"),
  },
  {
    path: "/profil/:page",
    component: () => import("@/pages/profil/Profil.vue"),
  },
];
